import Keycloak from 'keycloak-js';

const isProd = process.env.REACT_APP_ENV === 'production';

const keycloakConfig = {
  url: isProd ? 'https://auth.ttgteams.com/' : (process.env.REACT_APP_KEYCLOAK_URL || 'http://localhost:4000/'),
  realm: isProd ? 'talent' : (process.env.REACT_APP_KEYCLOAK_REALM || 'TA_local'),
  clientId: isProd ? 'talent' : (process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'TA_client'),
};

export const keycloak = new Keycloak(keycloakConfig);


